var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useContext } from "react";
import { CollapseButton } from "../Collapse";
import { DropdownContext } from "./Dropdown.context";
import { useMergeRefs } from "../../../common/useFallbackRef";
var DropdownButton = forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, style = _a.style, otherProps = __rest(_a, ["children", "className", "style"]);
    var contextValue = useContext(DropdownContext);
    var combinedRef = useMergeRefs([ref, contextValue === null || contextValue === void 0 ? void 0 : contextValue.refButton].filter(Boolean));
    if (!contextValue || !contextValue.refButton) {
        console.warn("DropdownContext provider is needed");
        return null;
    }
    return (React.createElement(CollapseButton, __assign({}, otherProps, { ref: combinedRef, className: className, style: style }), children));
});
export default DropdownButton;
